module.exports = __webpack_public_path__ + "static/media/favicon.bf67e92f.png";